<div class="panel-firmante-card"
     [ngStyle]="colorVars"
     [class.panel-firmante-card--expandido]="firmanteUi.seleccionado">
  <div class="panel-firmante-card__header" (click)="onHeaderClick()">
    <span class="panel-firmante-card__badge"></span>
    <h6 class="panel-firmante-card__titulo">{{ tipoFirmante.desc }}</h6>
    <button
      *ngIf="mostrarLimpiar"
      class="panel-firmante-card__clear"
      type="button"
      aria-label="Limpiar configuración en este documento"
      [matTooltip]="tooltipLimpiarEnDocumento"
      matTooltipPosition="above"
      (click)="onLimpiarClick($event)">
      <svg>
        <use xlink:href="#icon-delete-empty"></use>
      </svg>
    </button>
    <button
      *ngIf="puedeEliminarse"
      class="panel-firmante-card__delete"
      type="button"
      aria-label="Quitar firmante"
      [matTooltip]="tooltipQuitarFirmante"
      matTooltipPosition="above"
      (click)="onQuitarClick($event)">
      <svg>
        <use xlink:href="#hs-close"></use>
      </svg>
    </button>
    <svg class="panel-firmante-card__arrow" [class.panel-firmante-card__arrow--up]="firmanteUi.seleccionado">
      <use xlink:href="#hs-arrow"></use>
    </svg>
  </div>

  <div class="panel-firmante-card__body"
       *ngIf="firmanteUi.seleccionado"
       [class.panel-firmante-card__body--campos]="accionActiva === 'campos'"
       [class.panel-firmante-card__body--formularios]="accionActiva === 'formularios'"
       [class.panel-firmante-card__body--firma]="accionActiva === 'firma'">
    <div class="panel-firmante-card__acciones">
      <app-tarjeta-accion-firmante
        etiqueta="Firma"
        icono="#icon-signature"
        [estado]="estadoTarjeta('firma')"
        [configurada]="firmaConfigurada()"
        [resumen]="getResumenFirma()"
        (tarjetaClick)="onAccionClick('firma')"
        (configClick)="onFirmaConfig()">
      </app-tarjeta-accion-firmante>

      <app-tarjeta-accion-firmante
        *ngIf="permiteFormulariosYCampos()"
        [etiqueta]="etiquetaFormularios"
        icono="#icon-radio"
        [estado]="estadoTarjeta('formularios')"
        (tarjetaClick)="onAccionClick('formularios')"
        (configClick)="onAccionClick('formularios')"
        [mostrarDrag]="false">
      </app-tarjeta-accion-firmante>

      <app-tarjeta-accion-firmante
        *ngIf="permiteFormulariosYCampos()"
        [etiqueta]="etiquetaCampos"
        icono="#icon-text-field"
        [estado]="estadoTarjeta('campos')"
        (tarjetaClick)="onAccionClick('campos')"
        (configClick)="onAccionClick('campos')"
        [mostrarDrag]="false">
      </app-tarjeta-accion-firmante>

      <app-tarjeta-accion-firmante
        *ngIf="esPrimerFirmante"
        etiqueta="Tipos de contenido"
        icono="#icon-plantilla"
        [estado]="estadoTarjeta('tipos-contenido')"
        (tarjetaClick)="onAccionClick('tipos-contenido')"
        (configClick)="onAccionClick('tipos-contenido')"
        [mostrarConfig]="false"
        [mostrarDrag]="false">
      </app-tarjeta-accion-firmante>
    </div>

    <div class="panel-firmante-card__detalle panel-firmante-card__detalle--firma" *ngIf="accionActiva === 'firma'">
      <app-firma-wizard-inline #firmaWizard [firmante]="firmanteUi"></app-firma-wizard-inline>
    </div>

    <div class="panel-firmante-card__detalle panel-firmante-card__detalle--embedded panel-firmante-card__detalle--formularios"
         *ngIf="permiteFormulariosYCampos() && accionActiva === 'formularios'"
         (click)="onFormulariosInteract()">
      <app-formularios-firmante
        [firmante]="firmanteEmbed"
        [inlineMode]="true"
        (firmanteSeleccionado)="firmanteSeleccionado.emit($event)">
      </app-formularios-firmante>
    </div>

    <div class="panel-firmante-card__detalle panel-firmante-card__detalle--embedded panel-firmante-card__detalle--campos"
         *ngIf="permiteFormulariosYCampos() && accionActiva === 'campos'">
      <app-campos-editables-firmante
        [firmante]="firmanteEmbed"
        [inlineMode]="true"
        (firmanteSeleccionado)="firmanteSeleccionado.emit($event)">
      </app-campos-editables-firmante>
    </div>
  </div>
</div>
